import { useQuery } from 'react-query';

import { CustomsDocumentTypeControl, useCustomsDocumentTypesState } from '@/features/easy/shared/hooks';
import { CustomsDocumentType } from '@/features/easy/shared/types';
import { axios } from '@/lib/axios';

type GetCustomsDocumentTypesResponse = {
  customsDocumentTypeResponseList: CustomsDocumentType[];
};

type QueryParams = {
  folderId: string;
};

function getCustomsDocumentTypesByFolderIdAndTypologyIdAsync({ folderId }: QueryParams) {
  return axios.get<GetCustomsDocumentTypesResponse>(`/folders/${folderId}/customs-document-types-referential`);
}

export function useGetCustomsDocumentTypesByFolderIdAndTypologyIdAsync(
  { folderId }: QueryParams,
  {
    isEnabled,
  }: {
    isEnabled: boolean;
  },
) {
  return useQuery({
    retry: 3,
    enabled: isEnabled,
    queryKey: ['customs-document-types', folderId],
    queryFn: async () => {
      const { data } = await getCustomsDocumentTypesByFolderIdAndTypologyIdAsync({ folderId });
      return data?.customsDocumentTypeResponseList ?? [];
    },
    onSuccess: (data: CustomsDocumentType[]) => {
      const customsDocumentTypes = new Map<string, CustomsDocumentTypeControl>();
      data.forEach(
        ({
          id,
          fileAllowed,
          translationKey,
          validationRegex,
          referenceAllowed,
          displayedToApplicant,
          categoryTranslationKey,
        }) => {
          customsDocumentTypes.set(id, {
            id,
            fileAllowed,
            translationKey,
            referenceAllowed,
            displayedToApplicant,
            categoryTranslationKey,
            validationRegex: new RegExp(validationRegex),
          });
        },
      );
      useCustomsDocumentTypesState.setState({ customsDocumentTypes });
    },
  });
}
